import { Input, InputGroup, Span, type InputProps } from '@chakra-ui/react';
import type { FC } from 'react';
import { get, multiply, add, size } from 'lodash';

const InputSize: FC<InputProps & { onChange: (value: string) => void }> = (props) => {
  const { maxLength, value, onChange, ...rest } = props;
  const limitRef = useRef<HTMLSpanElement>(null);
  const [counterWidth, setCounterWidth] = useState(0);
  useEffect(() => {
    const element = limitRef.current;
    if (!element || !maxLength) return;
    const computedStyle = getComputedStyle(element);
    const fontSizeValue = parseFloat(computedStyle.fontSize);
    const width = add(multiply(fontSizeValue, size(String(maxLength))), 30);
    setCounterWidth(width);
    // const updateWidth = () => {
    //   setCounterWidth(element.clientWidth);
    // };
    // updateWidth();
    // const resizeObserver = new ResizeObserver(updateWidth);
    // resizeObserver.observe(element);
    // return () => {
    //   resizeObserver.unobserve(element);
    //   resizeObserver.disconnect();
    // };
  }, [maxLength]);
  return (
    <InputGroup
      endElement={
        <Span ref={limitRef} color="fg.muted" textStyle="xs">
          {get(value, 'length')} / {maxLength}
        </Span>
      }
    >
      <Input
        value={value || ''}
        maxLength={maxLength}
        onChange={(e) => {
          onChange?.(e.target.value);
        }}
        borderRadius="lg"
        fontSize="xs"
        color="fg"
        autoComplete="off"
        style={{
          paddingInlineEnd: counterWidth,
        }}
        {...rest}
      />
    </InputGroup>
  );
};
const MemoizedInputSize = memo(InputSize);

export { MemoizedInputSize as InputSize };
